import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { AppDefs, GuideDefs } from "./components/icons/defs";

import AppLoader from "./components/layouts/app-loader";
import AuthPages from "./components/auth";

import { AppProviders } from "./providers";
const Help = React.lazy(() => import("./components/help"));

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/help" render={() => (
          <React.Suspense fallback={<p role="status">Loading Help Center…</p>}>
            <Help />
          </React.Suspense>
        )} />
        <Route render={() => (
          <AppProviders>
            <CookiesProvider>
              <AppDefs />
              <GuideDefs />
              <Switch>
                <Route path="/auth" component={AuthPages} />
                <Route path="/" render={(props) => <AppLoader {...props} />} />
              </Switch>
            </CookiesProvider>
          </AppProviders>
        )} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
